export interface RelativeTimeRange {
    interval: TimeRangeInterval;
    value?: number;
    direction: TimeRangeDirection;
}

export class TimeRangePreset {
    constructor(
        public name: string,
        public interval: TimeRangeInterval,
        public value?: number,
        public direction = TimeRangeDirection.BeforeNow
    ) {}
}

export enum TimeRangeInterval {
    RelativeHours = 1,
    RelativeDays = 2,
    RelativeMonths = 3
}

export enum TimeRangeDirection {
    BeforeNow = 1,
    AfterNow = 2
}

export interface TimeRangeOption {
    id: number;
    timeRange: RelativeTimeRange;
    isCustom: boolean;
}

export const customizableTimeRangeOptions: TimeRangeOption[] = [
    {
        id: 1,
        isCustom: true,
        timeRange: {
            interval: TimeRangeInterval.RelativeHours,
            direction: TimeRangeDirection.BeforeNow,
            value: 8
        }
    },
    {
        id: 2,
        isCustom: true,
        timeRange: {
            interval: TimeRangeInterval.RelativeDays,
            direction: TimeRangeDirection.BeforeNow,
            value: 3
        }
    }
];
